import { shipmentApiClient } from '../shipmentApiClient'

import { downloadTenantShipmentAttachmentEndpoint } from './endpoint'
import type { DownloadTenantShipmentAttachmentParams } from './type'

/**
 * 出荷元担当者（テナント）向けの納品作業添付ファイルをダウンロードする。
 *
 * BE は Content-Disposition: attachment 固定でバイナリを返すため Blob で受け取る。
 * 呼び出し側で URL.createObjectURL(blob) を使ってダウンロードする。
 */
export const downloadTenantShipmentAttachment = async (
  params: DownloadTenantShipmentAttachmentParams
): Promise<Blob> => {
  const { data } = await shipmentApiClient.get<Blob>(
    downloadTenantShipmentAttachmentEndpoint(
      params.tenantId,
      params.shipmentId,
      params.visitId,
      params.attachmentId
    ),
    { responseType: 'blob' }
  )
  return data
}
